export function getDaysLeftToDate(date: Date) {
  const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
  const dateDiff = Math.round(
    (new Date().getTime() - (date.getTime() + oneDay)) / oneDay
  )
  return String(Math.max(0, -dateDiff)).padStart(2, '0')
}
